import { connect } from 'react-redux'
import { IStoreState, ITripFilters } from '../../types'
import AfterHoursReportPDF from '../../components/services/view/pdfs/AfterHoursReportPDF'
import { actionCreators, getManyTrips } from 'src/state/actions/trips'
import { getCurrentOrganization } from 'src/state/reducers/organizations'
export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const org = getCurrentOrganization(state)
  const serviceProducts = state.service.items[ownProps.match.params.id]
    ? state.service.items[ownProps.match.params.id].providerProducts
    : []
  return {
    isFetching: state.trips.isFetching,
    orgId: state.service.filters.organizationId,
    trips: state.trips.items,
    serviceProducts,
    orgName: org ? org.name : ''
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getManyTrips: (params: ITripFilters) => dispatch(getManyTrips(params)),
    setTripsEmpty: () => dispatch(actionCreators.setTripsEmpty())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AfterHoursReportPDF)



// WEBPACK FOOTER //
// ./src/containers/services/AfterHoursReportPDF.ts